<div class="container">
  <mic-breadcrumb id="make-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('makeText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="make-header">
    <h2 class="page-title make-heading" id="make-heading">{{ translationService.translate('makeText') }}</h2>
    <div class="action-bar">
      <button id="reset-filters" type="button" mat-flat-button color="accent" class="btn-clear make-action-button" (click)="resetFilters()">
        <mat-icon>refresh</mat-icon>
        {{ translationService.translate('clearSelectionText') }}
      </button>
      <span
        [matTooltip]="
          productSaveDisabled
            ? this.translationService.translate('comingSoonText')
            : !saveEnabled
            ? this.translationService.translate('userCannotSaveText')
            : !isModified
            ? this.translationService.translate('noModifiedText')
            : null
        "
        matTooltipPosition="above"
      >
        <button
          id="save"
          type="button"
          mat-flat-button
          color="primary"
          class="btn-primary make-action-button"
          [disabled]="!saveEnabled || !isModified"
          (click)="save()"
        >
          <mat-icon>save</mat-icon>
          {{ translationService.translate('saveLinkText') }}
        </button>
      </span>
      <button mat-flat-button color="primary" class="btn-export make-action-button" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        {{ translationService.translate('exportButtonText') }}
      </button>
    </div>
  </div>

  <mat-card class="make-filter-card">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <app-dropdown-search-single-select
          id="codeDropdown"
          label="{{ translationService.translate('searchByCodeText') }}"
          emptyPlaceholder="{{ translationService.translate('emptySelectCodeText') }}"
          placeholder="{{ translationService.translate('selectCodeText') }}"
          [formGroup]="filterForm"
          formControlName="codes"
          [data]="codeList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="descDropdown"
          label="{{ translationService.translate('searchByDescText') }}"
          emptyPlaceholder="{{ translationService.translate('emptySelectDescText') }}"
          placeholder="{{ translationService.translate('selectDescText') }}"
          [formGroup]="filterForm"
          formControlName="descriptions"
          [data]="descriptionList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="tierDropdown"
          label="{{ translationService.translate('searchByText') }}  {{ translationService.translate('tierText') }}"
          placeholder="{{ translationService.translate('selectText') }}  {{ translationService.translate('tierText') }}"
          [formGroup]="filterForm"
          formControlName="tiers"
          [data]="tierList"
        >
        </app-dropdown-search-single-select>
      </div>
    </form>
  </mat-card>

  <div id="make-table" class="cam-table table-container btn-table">
    <div class="table-wrapper">
      <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'tier'">
          <input
            id="TierInput"
            matInput
            type="number"
            min="0"
            [attr.aria-label]="translationService.translate('tierText')"
            [formControl]="getControl(item, 'tier')"
          />
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'rmVirginDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [widthConfig]="{ width: '100%' }"
            [data]="rollPartNumberList"
            [formControl]="getControl(item, 'dealerRMVirginSuffixNo')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'rmSuffixNonVirgin'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [widthConfig]="{ width: '100%' }"
            [data]="rollPartNumberList"
            [formControl]="getControl(item, 'dealerRMNonVirginSuffixNo')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'fgVirginDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [widthConfig]="{ width: '100%' }"
            [data]="finishedPartNumberList"
            [formControl]="getControl(item, 'dealerFGVirginSuffixNo')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'fgNonVirginDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [widthConfig]="{ width: '100%' }"
            [data]="finishedPartNumberList"
            [formControl]="getControl(item, 'dealerFGNonVirginSuffixNo')"
          ></mic-dropdown-search>
        </ng-container>
      </mic-table>
    </div>
  </div>

  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
